<template lang="pug">
  div
    slot(:products="products" :selected-product="selectedProduct" :select-product="selectProduct")
</template>

<script>
  import vueProductSvc from '@services/vueProductSvc';

  export default {
    name: 'Products',

    inject: ['getObjProperty'],

    data() {
      return {
        products: null,
        selectedProduct: null
      };
    },

    props: {
      productIds: {
        type: Array
      },

      productType: {
        type: String
      },

      defaultSelectedIndex: {
        type: Number
      },

      orderBy: {
        type: String
      },

      orderByNumber: {
        type: String
      }
    },

    methods: {
      selectProduct(product) {
        this.selectedProduct = product;
      },

      sortProducts(products) {
        if (this.orderBy) {
          return products.sort((a, b) => {
            let valueA = ('' + this.getObjProperty(a, this.orderBy)).toUpperCase();
            let valueB = ('' + this.getObjProperty(b, this.orderBy)).toUpperCase();

            return valueA < valueB ? -1 : 1;
          });
        } else if (this.orderByNumber) {
          return products.sort((a, b) => {
            let valueA = parseFloat(this.getObjProperty(a, this.orderBy));
            let valueB = parseFloat(this.getObjProperty(b, this.orderBy));

            return valueA < valueB ? -1 : 1;
          });
        }

        return products;
      }
    },

    created() {
      if (this.productIds) {
        vueProductSvc.getProductsById({ ids: this.productIds }).then(res => {
          this.products = this.sortProducts(res.data.filter(prod => prod.status && prod.visible));
          if (this.defaultSelectedIndex && this.products[this.defaultSelectedIndex]) {
            this.selectedProduct = this.products[this.defaultSelectedIndex];
          }
        });
      } else {
        vueProductSvc.getProductsByType({ productType: this.productType }).then(res => {
          this.products = this.sortProducts(res.data.filter(prod => prod.status && prod.visible));

          if (this.defaultSelectedIndex && this.products[this.defaultSelectedIndex]) {
            this.selectedProduct = this.products[this.defaultSelectedIndex];
          }
        });
      }
    }
  };
</script>
